import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener("turbo:before-frame-render", (event) => {
      event.target.className = event.detail.newFrame.className;
    });
  }
}
